import React from 'react';
import Tippy from '@tippy.js/react';
import {withTheme, defaultTheme} from '@elixir/theme';
import styles from './Tooltip-hashed.scss';

class Tooltip extends React.Component {

    static propTypes = Tippy.propTypes;
    // most props are inherited from https://atomiks.github.io/tippyjs/#all-options
    static defaultProps = {
        followCursor: false,
        placement: 'right',
        trigger: 'mouseenter focus',
        duration: [ 300, 300 ],
        hideOnClick: true,
        animation: 'fade',
        delay: [ 0, 20 ],
        sticky: true,
        flipBehavior: [
            'right', 'bottom', 'top', 'left', 'right' ],
        showOnInit: false,
        theme: defaultTheme
    };
    // some tippy options should not be configurable for user, styling is limited only to Elixir needs
    static nonConfigurableTippyProps = {
        a11y: true,
        animation: 'fade',
        animateFill: false,
        arrow: true,
        inertia: false,
        lazy: true,
        performance: true,
        interactive: true,
        size: 'regular',
        theme: 'dark'
    }

    constructor (props) {
        super(props);

        const theme = props.theme;
        const themeStyles = theme.getStyles('Tooltip', styles);

        const tooltipRootTag = 'div';
        this.tooltipWrapper = document.createElement(tooltipRootTag);
        this.tooltipWrapper.className = themeStyles.tooltip;
        document.body.appendChild(this.tooltipWrapper);
    }

    componentWillUnmount () {
        document.body.removeChild(this.tooltipWrapper);
    }

    render () {
        const {...tippyProps} = this.props;

        return (
            <Tippy
                {...tippyProps}
                {...Tooltip.nonConfigurableTippyProps}
                appendTo={this.tooltipWrapper}
            />
        );
    }
}

export default withTheme(Tooltip);
